import React from 'react'
import styles from "./heroes.module.css";
import { Box, Link, Modal, Typography } from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Head from "next/head";

function Index() {

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [newOpen, setNewOpen] = useState(false);
  
  const handleNewOpen = () => setNewOpen(true);
  const handleNewClose = () => setNewOpen(false);


  return (
    <>

   <Head>
    <title>Heroes: Jesus Christ & Hercules Archetypes | School of Our Divine Infinite Being</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Hero Archetype, Jesus Christ, Hercules, Heracles, Mythology, Religious Figures, Spiritual Heroes, Divine Theurgy, School of Our Divine Infinite Being"
    ></meta>
    <meta
      property="og:title"
      content="Exploring the Hero Archetypes: Jesus Christ & Hercules"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/heroes_archetypes_og_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="A collage of heroic and spiritual figures including Jesus Christ and Buddha, representing the study of hero archetypes."
    ></meta>
    <meta
      property="og:description"
      content="Explore the powerful hero archetypes of Jesus Christ and Hercules. Delve into the historical, mythological, and spiritual significance of these iconic figures in our school's teachings."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/heroes"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/heroes_archetypes_og_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="A collage of heroic and spiritual figures including Jesus Christ and Buddha, representing the study of hero archetypes."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/heroes"
    ></meta>
    <meta
      name="twitter:title"
      content="Exploring the Hero Archetypes: Jesus Christ & Hercules"
    ></meta>
    <meta
      name="twitter:description"
      content="Explore the powerful hero archetypes of Jesus Christ and Hercules. Delve into the historical, mythological, and spiritual significance of these iconic figures in our school's teachings."
    ></meta>
    <link rel="canonical" href="https://www.divineinfinitebeing.com/heroes" />
</Head>







    <div className={styles.heroes_page_full_width}>

      <div className={styles.heroes_blockone}>
        {/* {/ <!------Main Banner section-------> /} */}
        <div className={styles.heroes_banner_main_wrpr}>
          <div className={styles.heroes_banner_left}>
            <div className={styles.bannerLogo}>
              <span className={styles.logoviewlink} onClick={handleOpen}>
                <img src={`${process.env.cloud_url2}assets/images/viewicon.png`}/>
              </span>
              <img src={`${process.env.cloud_url2}assets/images/logobanner.webp`}/>
            </div>
            <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
            <h1 data-text="infinite being">INFINITE BEING</h1>

            <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
            <div
              className={`${styles.heroes_bottombannerbg} ${styles.bannerboxtxt}`}
            >
              <div className={styles.yellow_bar}></div>
            </div>
          </div>
        </div>
      </div>


      <div className={styles.heroes_full_block_sec}>

        <div className={styles.common_width}>
          <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
            <div className={styles.column}>
              <div className={`${styles.col12} ${styles.bgifive}`}>
                <h1>Heroes</h1>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.b_common_width}>

         <div className={styles.block_sec_full_sec}>

          <div className={styles.heroes_intro_sec}>
            <div className={styles.heroes_intro_left_cont}>
              <div className={styles.intro_heading_sec}>
                <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_intro_heading_img.webp'></img>
                <h1>Inroduction</h1>
              </div>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </div>
          </div>
         
          <div className={styles.block1_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Jesus Christ</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={styles.heroes_block1_wrp}>
                  <div className={styles.heroes_cont_box}>
                    <p>Jesus also referred to as Jesus Christ, Jesus of Nazareth, and many other names and titles, was a first-century Jewish preacher and religious leader. He is the central figure of Christianity, the world's largest religion. Most Christians believe Jesus to be the incarnation of God the Son and the awaited messiah, the Christ that is prophesied in the Hebrew Bible.</p>

                    <p>Virtually all modern scholars of antiquity agree that Jesus existed historically. Accounts of Jesus' life are contained in the Gospels, especially the four canonical Gospels in the New Testament. Academic research has yielded various views on the historical reliability of the Gospels and how closely they reflect the historical Jesus. As a Galilean Jew, Jesus was circumcised at birth, got baptized by John the Baptist as a young adult, and after 40 days and nights of fasting in the wilderness, began his own ministry. He was often referred to as <span>"rabbi"</span>. Jesus often debated with fellow Jews on how to best follow God, engaged in healings, taught in parables, and gathered followers, among them twelve were his primary disciples. He was arrested in Jerusalem and tried by the Jewish authorities, turned over to the Roman government, and crucified on the order of Pontius Pilate, the Roman prefect of Judea. After his death, his followers became convinced that he rose from the dead, and following his ascension, the community they formed eventually became the early Christian Church that expanded as a worldwide movement. Accounts of his teachings and life were initially conserved by oral transmission, which was the source of the written Gospels.</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_jesus_christ_d_img.webp'></img>
                    {/* <img src={`${process.env.cloud_url}central-doctrine/pentagram_ritual/as_pentagram_block1_box_image1.webp`}/> */}
                  </div>
                </div>
              </div>

              <div className={`${styles.heroes_block1_wrp} ${styles.wrpr_left}`}>
                <div className={styles.heroes_cont_box}>
                  <p>Christian theology includes the beliefs that Jesus was conceived by the Holy Spirit, was born of a virgin named Mary, performed miracles, founded the Christian Church, died by crucifixion as a sacrifice to achieve atonement for sin, rose from the dead, and ascended into Heaven, from where he will return. Commonly, Christians believe Jesus enables people to be reconciled to God. <span>The Nicene Creed asserts that Jesus will judge the living and the dead, either before or after their bodily resurrection, an event tied to the Second Coming of Jesus in Christian eschatology.</span> The great majority of Christians worship Jesus as the incarnation of God the Son, the second of three prosopons of the Trinity.[h] The birth of Jesus is celebrated annually on 25 December and 7 January as Christmas.[i] His crucifixion is honored on Good Friday and his resurrection on Easter Sunday. The world's most widely used calendar era—in which the current year is AD 2024 (or 2024 CE)—is based on the approximate birthdate of Jesus.</p>

                  <p>Jesus is also revered in the Baha'i faith, the Druze faith, and Islam. In Islam, Jesus (often referred to by his Quranic name ʿĪsā) is considered the penultimate prophet of God and the messiah, who will return before the Day of Judgement. Muslims believe Jesus was born of the virgin Mary but was neither God nor a son of God. Most Muslims do not believe that he was killed or crucified but that God raised him into Heaven while he was still alive. In contrast, Judaism rejects the belief that Jesus was the awaited messiah, arguing that he did not fulfill messianic prophecies, was not lawfully anointed and was neither divine nor resurrected.</p>
                </div>

                <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                  <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_jesus_christ_2nd_img.webp'></img>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.block2_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Hercules</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={styles.heroes_block1_wrp}>
                  <div className={styles.heroes_cont_box}>
                    <p>Hercules, the renowned designation under which the people of Rome are acquainted with the revered Greek divine hero known as Heracles, occupies a position of great significance within the realm of mythology and the legends of ancient epochs. Hercules, who came into existence as the offspring of Jupiter and Alcmena, a mere mortal woman, has acquired an immense amount of acclaim and acknowledgment due to his extraordinary physical prowess and a myriad of extraordinary exploits.</p>

                    <p>Moreover, the Romans, having been deeply influenced by the rich tapestry of Greek culture, have seamlessly integrated an array of iconic imagery and captivating tales pertaining to this <span>Greek hero into their own literary compositions and artistic creations.</span> Over the course of the progression of time, the appellation of Hercules gradually eclipsed that of Heracles, emerging as the predominant designation for this iconic figure within the realm of Western art, literature, and popular culture.</p>

                    <p>The allure of Hercules resides within the multifaceted nature that he possesses, a phenomenon that presents a paradoxical blend of characteristics. This intriguing complexity offers later artists and writers an unparalleled degree of creative liberty, thereby granting them the ability to depict and interpret Hercules in accordance with their individual artistic vision and narrative objectives.</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_hercules_img.webp'></img>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.block3_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Buddha</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={`${styles.heroes_block1_wrp} ${styles.wrpr_left}`}>
                  <div className={styles.heroes_cont_box}>
                    <p>Siddhartha Gautama, most commonly referred to as the Buddha ('the awakened'), was a wandering ascetic and religious teacher who lived in South Asia during the 6th or 5th century BCE and founded Buddhism.</p>

                    <p>According to Buddhist tradition, he was born in Lumbini, in what is now Nepal, to royal parents of the Shakya clan, but renounced his home life to live as a wandering ascetic (Sanskrit: śramaṇa). After leading a life of mendicancy, asceticism, and meditation, he attained enlightenment at Bodh Gaya in what is now India. <span>The Buddha thereafter wandered through the lower Indo-Gangetic Plain, teaching and building a monastic order.</span> He taught a Middle Way between sensual indulgence and severe asceticism, leading to Nirvana, that is, freedom from ignorance, craving, rebirth, and suffering. His teachings are summarized in the Noble Eightfold Path, a training of the mind that includes ethical training and meditative practices such as sense restraint, kindness toward others, mindfulness, and jhana/dhyana (meditation proper). He died in Kushinagar, attaining parinirvana. The Buddha has since been venerated by numerous religions and communities across Asia.</p>

                    <p>A couple of centuries after his death, he came to be known by the title Buddha, which means 'Awakened One' or <span>'Enlightened One'</span>. His teachings were compiled by the Buddhist community in the Vinaya, his codes for monastic practice, and the Sutta Piṭaka, a compilation of teachings based on his discourses. These were passed down in Middle Indo-Aryan dialects through an oral tradition. Later generations composed additional texts, such as systematic treatises known as Abhidharma, biographies of the Buddha, collections of stories about his past lives known as Jataka tales, and additional discourses, i.e., the Mahayana sutras.</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_buddha_img.webp'></img>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.block4_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Krishna</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={styles.heroes_block1_wrp}>
                  <div className={styles.heroes_cont_box}>
                    <p>Krishna is a major deity in Hinduism. He is worshipped as the eighth avatar of Vishnu and also as the Supreme God in his own right. He is the god of protection, compassion, tenderness, and love; and is one of the most popular and widely revered among Hindu divinities. Krishna's birthday is celebrated every year by Hindus on Krishna Janmashtami according to the lunisolar Hindu calendar, which falls in late August or early September of the Gregorian calendar.</p>

                    <p>The anecdotes and narratives of Krishna's life are generally titled as Krishna Līlā. He is a central figure in the Mahabharata, the <span>Bhagavata Purana, the Brahma Vaivarta Purana, and the Bhagavad Gita, and is mentioned in many Hindu philosophical, theological, and mythological texts.</span> They portray him in various perspectives: as a god-child, a prankster, a model lover, a divine hero, and the universal supreme being. His iconography reflects these legends, and shows him in different stages of his life, such as an infant eating butter, a young boy playing a flute, a young boy with Radha or surrounded by female devotees; or a friendly charioteer giving counsel to Arjuna.</p>

                    <p>The name and synonyms of Krishna have been traced to 1st millennium BCE literature and cults. In some sub-traditions, like Krishnaism, Krishna is worshipped as Svayam Bhagavan (the Supreme God). These sub-traditions arose in the context of the medieval era Bhakti movement. <span>Krishna-related literature has inspired numerous performance arts such as Bharatanatyam, Kathakali, Kuchipudi, Odissi, and Manipuri dance.</span> He is a pan-Hindu god, but is particularly revered in some locations, such as Vrindavan in Uttar Pradesh, Dwarka and Junagadh in Gujarat; the Jagannatha aspect in Odisha, Mayapur in West Bengal; in the form of Vithoba in Pandharpur, Maharashtra, Shrinathji at Nathdwara in Rajasthan, Udupi Krishna in Karnataka, Parthasarathy in Tamil Nadu and in Aranmula, Kerala, and Guruvayoorappan in Guruvayoor in Kerala. Since the 1960s, the worship of Krishna has also spread to the Western world and to Africa, largely due to the work of the International Society for Krishna Consciousness (ISKCON).</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_krishna_img.webp'></img>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.block5_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Arjuna</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={`${styles.heroes_block1_wrp} ${styles.wrpr_left}`}>
                  <div className={styles.heroes_cont_box}>
                    <p>Arjuna also known as Partha and Dhananjaya, a protagonist of the Hindu epic Mahabharata. In the epic he is the third of five Pandava brothers, from the lineage of the Kuru. In the Mahabharata War, Arjuna was a key warrior from the Pandava side and killed many warriors. Before the beginning of the war, his mentor Krishna gave him the supreme knowledge of the Bhagavad Gita to overcome his moral dilemmas.</p>

                    <p>Arjuna was the son of Kunti, the wife of Kuru King Pandu, and the god Indra, who fathered him due to Pandu's curse. In the Mahabharata, Arjuna is depicted as a skilled archer from an early age, as a student who earns the favor of his preceptor Drona, as the primary adversary of Kauravas, and the betrothed of Draupadi, who became the common wife of the Pandavas. Arjuna is twice exiled, first for breaking a pact with his brothers, and again with his brothers after his oldest brother is tricked into gambling away the throne. <span>During his first exile, Arjuna married Ulupi, Chitrāngadā and Subhadra. From his four wives, Arjuna had four sons, one from each wife — Shrutakarma, Iravan, Babhruvahana and Abhimanyu.</span> During his second exile, Arjuna gained many celestial weapons. Despite being a warrior, Arjuna also possessed skills in music and dance. At the end of the epic the Pandavas, accompanied by Draupadi, retire to the Himalayas, where everyone in time passes away to arrive in Heaven.</p>

                    <p>In addition to his skill in battle and his multi-faceted character, Arjuna lived a life full of spiritual experiences. His path was not limited to the battlefield, but he also embarked on a journey of self-discovery and spiritual growth. Arjuna’s encounter with Lord Krishna at the battle-field of kurukshetra went beyond mere mentorship. Krishna taught him the teachings of the bhagavad gita. Krishna taught him not only about war, but also about justice, duty and the nature of life. Krishna’s spiritual discourse played an important role in shaping the character of Arjuna and contributing to the epic’s timeless message of balance between action and thought, duty and loyalty. As a result of Krishna’s teachings, Arjuna exemplifies not only the bravery of a warrior but also the transformational power of spiritual wisdom beyond the temporal struggles of a mortal life.</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_arjuna_nw_img.webp'></img>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.block6_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Rama</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={styles.heroes_block1_wrp}>
                  <div className={styles.heroes_cont_box}>
                    <p>Rama is a major deity in Hinduism. He is the seventh and one of the most popular avatars of Vishnu. In Rama-centric traditions of Hinduism, he is considered the Supreme Being.</p>

                    <p>Rama was born to Kaushalya and Dasharatha in Ayodhya, the capital of the Kingdom of Kosala. His siblings included Lakshmana, Bharata, and Shatrughna. He married Sita. Though born in a royal family, Rama's life is described in the Hindu texts as one challenged by unexpected changes, such as an exile into impoverished and difficult circumstances, and challenges of ethical questions and moral dilemmas. Of all his travails, the most notable is the kidnapping of Sita by demon-king Ravana, followed by the determined and epic efforts of Rama and Lakshmana to gain her freedom and destroy the evil Ravana against great odds.</p>

                    <p>The entire life story of Rama, Sita and their companions allegorically discusses duties, rights and social responsibilities of an individual. It illustrates dharma and dharmic living through model characters.</p>

                    <p>Rama is especially important to Vaishnavism. <span>He is the central figure of the ancient Hindu epic Ramayana, a text historically popular in the South Asian and Southeast Asian cultures.</span> His ancient legends have attracted bhasya (commentaries) and extensive secondary literature and inspired performance arts. Two such texts, for example, are the Adhyatma Ramayana – a spiritual and theological treatise considered foundational by Ramanandi monasteries, and the Ramcharitmanas – a popular treatise that inspires thousands of Ramlila festival performances during autumn every year in India.</p>

                    <p>Rama legends are also found in the texts of Jainism and Buddhism, though he is sometimes called Pauma or Padma in these texts, and their details vary significantly from the Hindu versions. Jain Texts also mentioned Rama as the eighth balabhadra among the 63 salakapurusas. In Sikhism, Rama is mentioned as one of twenty-four divine avatars of Vishnu in the Chaubis Avtar in Dasam Granth.</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_rama_img.webp'></img>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.block7_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Prahlad</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={`${styles.heroes_block1_wrp} ${styles.wrpr_left}`}>
                  <div className={styles.heroes_cont_box}>
                    <p>Prahlada is an asura king in Hindu mythology. He is known for his staunch devotion to the preserver deity, Vishnu. He appears in the narrative of Narasimha, the man-lion avatar of Vishnu, who rescues Prahlada by slaying his wicked father, Hiranyakashipu.</p>

                    <p>Prahlada is described as a saintly boy, known for his innocence and bhakti towards Vishnu. <span>Despite the abusive nature of his father, Hiranyakashipu, he continues to worship Vishnu.</span> He is considered a mahājana, or great devotee, by followers of Vaishnava traditions. A treatise is attributed to him in the Bhagavata Purana, in which Prahlada describes the process of his loving worship towards Vishnu.</p>

                    <p>The majority of stories in the Puranas regarding him are based on the activities of Prahlada as a young boy, and he is usually depicted as such in paintings and illustrations.</p>

                    <p>Prahlada is further than just a child saint in Hindu tradition. His story is a testament to the power of faith and the triumph of justice over wrong. His belief in Vishnu is imperturbable, indeed as his father relentlessly pursues him. Prahlada's story is also a classic able of the eternal battle of good vs. wrong, with godly intervention bringing balance and justice to the world. His story transcends his particular struggles, and resonates as a memorial of godly mercy and the adaptability of faith through adversity, all woven together in the intricate shade that's Hindu tradition.</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_prahlad_nw_img.webp'></img>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.block8_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Elohim</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={styles.heroes_block1_wrp}>
                  <div className={styles.heroes_cont_box}>
                    <p>Elohim is a Hebrew word meaning "gods" or "godhood". Although the word is plural, in the Hebrew Bible it most often takes singular verbal or pronominal agreement and refers to a single deity, particularly the God of Israel in the majestic plural. In other verses it refers to the singular gods of other nations or to deities in the plural.</p>

                    <p>Morphologically, the word is the plural form of the word eloah and related to el. It is cognate to the word 'l-h-m which is found in Ugaritic, where it is used as the pantheon for Canaanite gods, the children of El, and conventionally vocalized as <span>"Elohim"</span>. Most uses of the term Elohim in the later Hebrew text imply a view that is at least monolatrist at the time of writing, and such usage (in the singular), as a proper title for Deity, is distinct from generic usage as elohim, "gods" (plural, simple noun).</p>

                    <p>Rabbinic scholar Maimonides wrote that Elohim <span>"Divinity"</span> and elohim <span>"gods"</span> are commonly understood to be homonyms. One modern theory suggests that the notion of divinity underwent radical changes in the early period of Israelite identity and development of Ancient Hebrew religion. In this view, the ambiguity of the term elohim is the result of such changes, cast in terms of "vertical translatability", i.e. the re-interpretation of the gods of the earliest recalled period as the national god of monolatrism as it emerged in the 7th to 6th century BCE in the Kingdom of Judah and during the Babylonian captivity, and further in terms of monotheism by the emergence of Rabbinical Judaism in the 2nd century CE. Another theory, building on an idea by Gesenius, argues that even before Hebrew became a distinct language, the plural elohim had both a plural meaning of "gods" and an abstract meaning of <span>"godhood"</span> or <span>"divinity"</span>, much as the plural of "father", avot, can mean either "fathers" or "fatherhood". Elohim then came to be used so frequently in reference to specific deities, both male and female, domestic and foreign (for instance, the goddess of the Sidonians in 1 Kings 11:33), that it came to be concretized from meaning "divinity" to meaning "deity", though still occasionally used adjectivally as "divine".</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_elohim_img.webp'></img>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.block9_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Prometheus</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={`${styles.heroes_block1_wrp} ${styles.wrpr_left}`}>
                  <div className={styles.heroes_cont_box}>
                    <p>Prometheus is a mass of compressed flames with several sunrays surrounding him, giving him the appearance of an abstract drawing of the sun. His eyes and nose are very close together, and are small compared to his large mouth. He has blushy, rosy cheeks and is usually seen with a toothy smile. <span>When he uses his power, his appearance changes, resembling a fireball while his facial features remain, though he can take on a more sinister appearance.</span> While sleeping, Prometheus does not exude any sun rays nor light, instead appearing a mere orb with a face floating in midair.</p>

                    <p>When he was initially described by Pound, he had a fierier appearance and was surrounded by fireballs rather than sunrays. His facial features consisted of only slanted, pupilless eyes and a mouth. He took this appearance when joining with Big Mom to attack the Thousand Sunny.</p>

                    <p>Prometheus is very similar in appearance to his predecessor created by Carmel, Pandora, down to having a second more fireball-like appearance - though Prometheus lacks eyelashes, has a smaller face compared to his body, and tends to have forehead lines when smiling.</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_prometheus_img.webp'></img>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.block10_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Julian the Emperor</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={styles.heroes_block1_wrp}>
                  <div className={styles.heroes_cont_box}>
                    <p>Julian (331 – 26 June 363) was the Caesar of the West from 355 to 360 and Roman emperor from 361 to 363, as well as a notable philosopher and author in Greek. His rejection of Christianity, and his promotion of Neoplatonic Hellenism in its place, caused him to be remembered as Julian the Apostate in Christian tradition. He is sometimes referred to as Julian the Philosopher.</p>

                    <p>A nephew of Constantine the Great, Julian was one of few in the imperial family to survive the purges and civil wars during the reign of Constantius II, his cousin. <span>Julian became an orphan as a child after his father was executed in 337, and spent much of his life under Constantius's close supervision.</span> However, the emperor allowed Julian to freely pursue an education in the Greek-speaking east, with the result that Julian became unusually cultured for an emperor of his time. In 355, Constantius II summoned Julian to court and appointed him to rule Gaul. Despite his inexperience, Julian showed unexpected success in his new capacity, defeating and counterattacking Germanic raids across the Rhine and encouraging the ravaged provinces' return to prosperity. In 360, he was proclaimed emperor by his soldiers at Lutetia (Paris), sparking a civil war with Constantius. However, Constantius died before the two could face each other in battle, and named Julian as his successor.</p>

                    <p>In 363, Julian embarked on an ambitious campaign against the Sasanian Empire. The campaign was initially successful, securing a victory outside Ctesiphon in Mesopotamia. However, he did not attempt to besiege the capital. Julian instead moved into Persia's heartland, but he soon faced supply problems and was forced to retreat northwards while being ceaselessly harassed by Persian skirmishers. During the Battle of Samarra, Julian was mortally wounded. He was succeeded by Jovian, a senior officer in the imperial guard, who was obliged to cede territory, including Nisibis, in order to save the trapped Roman forces.</p>

                    <p>Julian was the last non-Christian ruler of the Roman Empire, and he believed that it was necessary to restore the Empire's ancient Roman values and traditions in order to save it from dissolution. He purged the top-heavy state bureaucracy, and attempted to revive traditional Roman religious practices at the expense of Christianity. His attempt to build a Third Temple in Jerusalem was probably intended to harm Christianity rather than please Jews. Julian also forbade Christians from teaching and learning classical texts.</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_julian_the_emperor_img.webp'></img>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.block11_main_width}>
            <div className={styles.brown_box_full_width}>

              <div className={styles.heroes_brown_heading_box_wrapper}>
                <div className={styles.heroes_brown_heading_box}>
                  <h2>Marcus Aurelius</h2>
                </div>
              </div>

              <div className={styles.img_content_sec_main}>
                <div className={`${styles.heroes_block1_wrp} ${styles.wrpr_left}`}>
                  <div className={styles.heroes_cont_box}>
                    <p>Marcus Aurelius Antoninus (26 April 121 – 17 March 180) was Roman emperor from 161 to 180 AD and a Stoic philosopher. He was a member of the Nerva–Antonine dynasty, the last of the rulers later known as the Five Good Emperors and the last emperor of the Pax Romana, an age of relative peace, calm, and stability for the Roman Empire lasting from 27 BC to 180 AD. He served as Roman consul in 140, 145, and 161.</p>

                    <p>Marcus Aurelius was the son of the praetor Marcus Annius Verus and his wife, Domitia Calvilla. He was related through marriage to the emperors Trajan and Hadrian. Marcus's father died when he was three, and he was raised by his mother and paternal grandfather. After Hadrian's adoptive son, Aelius Caesar, died in 138, Hadrian adopted Marcus's uncle Antoninus Pius as his new heir. In turn, Antoninus adopted Marcus and Lucius, the son of Aelius. Hadrian died that year, and Antoninus became emperor. Now heir to the throne, Marcus studied Greek and Latin under tutors such as Herodes Atticus and Marcus Cornelius Fronto. He married Antoninus's daughter Faustina in 145.</p>

                    <p>After Antoninus died in 161, Marcus Aurelius acceded to the throne alongside his adoptive brother, who reigned under the name Lucius Verus. Under his rule the Roman Empire witnessed heavy military conflict. In the East, the Romans fought successfully with a revitalized Parthian Empire and the rebel Kingdom of Armenia. Marcus defeated the Marcomanni, Quadi, and Sarmatian Iazyges in the Marcomannic Wars; however, these and other Germanic peoples began to represent a troubling reality for the Empire. He reduced the silver purity of the Roman currency, the denarius. The persecution of Christians in the Roman Empire appears to have increased during his reign, but his involvement in this is unlikely since there is no record of early Christians in the 2nd century calling him a persecutor, and Tertullian even called Marcus a <span>"protector of Christians"</span>. The Antonine Plague broke out in 165 or 166 and devastated the population of the Roman Empire, causing the deaths of five to ten million people. Lucius Verus may have died from the plague in 169.</p>

                    <p>Unlike some of his predecessors, Marcus chose not to adopt an heir. His children included Lucilla, who married Lucius, and Commodus, whose succession after Marcus has been a subject of debate among both contemporary and modern historians. The Column and Equestrian Statue of Marcus Aurelius still stand in Rome, where they were erected in celebration of his military victories. Meditations, the writings of <span>"the philosopher"</span> – as contemporary biographers called Marcus – are a significant source of the modern understanding of ancient Stoic philosophy. These writings have been praised by fellow writers, philosophers, monarchs, and politicians centuries after his death.</p>
                  </div>

                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/heroes/heroes_marcus_aurelius_nw_img.webp'></img>
                  </div>
                </div>
              </div>

            </div>
          </div>

         </div>

        </div>

      </div>




      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box">
          <Typography
            id="modal-modal-description" component="div"
            sx={{ mt: 2 }}
            className="modal_banner"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleClose}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
            </div>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={newOpen}
        onClose={handleNewClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box_new">
          <Typography
            id="modal-modal-description" component="div"
            sx={{ mt: 2 }}
            className="modal_banner_new"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleNewClose}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
              <p className="modal_commingsoon">Coming soon</p>
            </div>
          </Typography>
        </Box>
      </Modal>

    </div>

    <div className={styles.heroes_page_demo_image}>
        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/heroes/divine_heroes_page_banner_img.webp'></img> */}
        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/heroes/divine_heroes_page_block1_2_img.webp'></img> */}
        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/heroes/divine_heroes_page_block3_4_5_img.webp'></img> */}
        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/heroes/divine_heroes_page_block6_7_8_img.webp'></img> */}
        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/heroes/divine_heroes_page_block9_10_11_img.webp'></img> */}
    </div>

    </>
  )
}

export default Index
